export { TableSection } from './table-section'
export type { TableSectionProps } from './table-section'
